export default __webpack_public_path__ + "static/media/char_card_frame3.c05e6efe.png";